/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Sort_OverriddenInputs */



/**
* | output |
* | --- |
* | "Blocked partners lead, oldest first — sorting orders the rest." |
*
* @param {Partner_Billing_Board_Sort_OverriddenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_sort_overridden = /** @type {((inputs?: Partner_Billing_Board_Sort_OverriddenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Sort_OverriddenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Blockierte Partner stehen oben, älteste zuerst — die Sortierung ordnet den Rest.")
	return /** @type {LocalizedString} */ ("Blocked partners lead, oldest first — sorting orders the rest.")
});